import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import PopupBase from "../../../popup/base/PopupBase";
import CustomButton from "../../../components/buttons/CustomButton";
import { DataProviderInstance } from '../../../api/DataProvider';
import SourceAvatar from '../shared/SourceAvatar';
import shared from '../shared/MarketingShared.module.css';

function CreateEditSourcePopup(props) {
  const { Data, OnHide, OnUpdate } = props;

  const { SetMarketingChannel, UpdateMarketingChannel } = DataProviderInstance();

  const [sourceData, setSourceData] = useState({
    id: Data?.id || null,
    name: Data?.name || "",
  });

  const [nameError, setNameError] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleChange = (field, value) => {
    setSourceData({ ...sourceData, [field]: value });
    setNameError(false);
    setSaveError("");
  };

  // Só fecha quando o servidor confirma; senão o erro aparece no popup.
  // OnUpdate recebe a resposta (source_id na criação) e se era edição.
  const onSaveResponse = (response) => {
    setSaving(false);
    if (response?.status == "success") {
      OnUpdate(response, Boolean(Data));
      OnHide();
      return;
    }
    setSaveError(response?.message || response?.error || "Não foi possível salvar a origem. Tente novamente.");
  };

  const createSource = () => {
    setSaving(true);
    SetMarketingChannel(sourceData, onSaveResponse);
  };

  const updateData = () => {
    setSaving(true);
    UpdateMarketingChannel(sourceData, onSaveResponse);
  };

  const saveClickHandler = () => {
    if (!String(sourceData.name || "").trim()) {
      setNameError(true);
      return;
    }

    if (Data) {
      updateData();
    } else {
      createSource();
    }
  };

  const footer = (
    <div className={shared.footer}>
      <CustomButton label="Cancelar" variant="text" onClick={OnHide} />
      <CustomButton
        variant="contained"
        style="main"
        label={Data ? "Salvar alterações" : "Adicionar"}
        onClick={saveClickHandler}
        enabled={!saving}
      />
    </div>
  );

  const content = (
    <div className={shared.form}>
      {saveError && <Alert severity="error">{saveError}</Alert>}

      <div className={shared.field}>
        <label className={shared.label} htmlFor="source-name">
          Nome da origem<span className={shared.required}>*</span>
        </label>
        <TextField
          id="source-name"
          fullWidth
          size="small"
          placeholder="Ex.: Instagram, Google, Indicação"
          value={sourceData.name}
          onChange={(e) => handleChange("name", e.target.value)}
          required
          autoFocus
          className={shared.input}
          InputProps={{
            startAdornment: <span style={{ marginRight: 10, display: 'inline-flex' }}><SourceAvatar name={sourceData.name} size="sm" /></span>,
          }}
          error={nameError}
          helperText={nameError ? "Preencha o nome da origem" : "De onde os leads chegam até você."}
        />
      </div>
    </div>
  );

  return (
    <PopupBase
      Title={Data ? "Editar origem" : "Nova origem"}
      Content={content}
      Footer={footer}
      OnClose={OnHide}
      maxWidth="sm"
    />
  );
}

export default CreateEditSourcePopup;
